/**
 * Cookier is a simpler interface to a cookie
 *
 * let cookie = new Cookier('cookie-name');
 *
 * cookie.get(); // returns raw cookie data
 * cookie.set(string); // set cookie to string
 */

class Cookier
{
  constructor(name)
  {
    this.name = name;
  }

  set(value, exdays)
  {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    let c_value = escape(value) + ((exdays === null) ? '' : '; expires=' + exdate.toUTCString());

    document.cookie = this.name + '=' + c_value + '; path=/';
  }

  get()
  {
    let i, x, y;
    let ARRcookies = document.cookie.split(';');

    for (i = 0;i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === this.name) {
        return unescape(y);
      }
    }
  }
}

export default Cookier;



// WEBPACK FOOTER //
// ./src/assets/js/classes/cookier.class.js